import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useHistory } from "react-router";


const Login = () => {

    let history = useHistory()

    const [input, setInput] = useState({
        email : "",
        password : ""
    })

    const handleChange = (e) => {

        let {value, name} = e.target

        setInput ({...input, [name] : value})
    }

    const handleLogin = (e) => {
        e.preventDefault()
        console.log(input)

        let {email, password} = input

        axios.post('https://backendexample.sanbersy.com/api/user-login' , {email, password}
        ).then((res)=>{
        let data = res.data
        let {token, user} = data

        Cookies.set('token', token, {expires : 1} )
        Cookies.set('user', JSON.stringify(user), {expires : 1})

        history.push("/")
        }).catch((e) => { 
        let {error} = e.response.data
        alert(error)
    })
    
    }

    return (
        <div>
            <form onSubmit={handleLogin} style={{marginTop: "100px"}}>
                <input required value={input.email} onChange={handleChange} name="email" type="email" placeholder="Email" />
                <input required value={input.password} onChange={handleChange} name="password" type="password" placeholder="Password"/>
                <input type="submit" value="Login" />
            </form>
        </div>
    )
}

export default Login